var version = {
    "name":      "dativery",
    "buildDateCode": "20260707-151025",
    "buildDate": "Tue Jul 07 2026 15:10:25 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260707-151025",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;